import React from 'react';
import ContentLoader from 'react-content-loader';

import { times } from 'lodash';

import AppointmentsListContainer from './AppointmentsListContainer';
import AppointmentItem from './AppointmentItem';

const ContentLoading = () => (
  <AppointmentsListContainer>
    {times(3).map((n) => (
      <AppointmentItem.Container key={n} id={n} isRescheduleEnabled={false}>
        <ContentLoader height={42} width={224}>
          <rect x="78" y="0" rx="0" ry="6" width="68" height="16" />
          <rect x="29" y="24" rx="0" ry="0" width="166" height="16" />
        </ContentLoader>
      </AppointmentItem.Container>
    ))}
  </AppointmentsListContainer>
);

export default ContentLoading;
